export default {"src":"/customer-services/_next/static/media/clock-icon.92398f53.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};